import { ApolloLink, Operation } from '@apollo/client';
import { WORKSPACE_AUTH_ME } from '@/graphql/query.graphql';
import { cache } from '../cache';
import { suspendedAccountEnabledRoutes } from '../constants';
import { workspaceAuthMeV2Query } from '@/types/generated/graphql';

function isQueryOperation(operation: Operation) {
  return operation.query.definitions?.[0] && 'operation' in operation.query.definitions[0]
    ? (operation.query.definitions[0] as { operation: string }).operation === 'query'
    : false;
}

export const suspendedAccountLink = new ApolloLink((operation, forward) => {
  const wksData: workspaceAuthMeV2Query | null = cache.readQuery({ query: WORKSPACE_AUTH_ME });
  const accountIsSuspended = wksData?.workspaceAuthMeV2?.data?.status === 'payment_failed';
  const suspendedEnabledApis = suspendedAccountEnabledRoutes.includes(operation.operationName);

  // WHEN ACCOUNT IS SUSPENDED
  if (accountIsSuspended && !suspendedEnabledApis && isQueryOperation(operation)) {
    return null;
  }

  return forward(operation);
});
